module.exports = __webpack_public_path__ + "static/media/cross-black.c5b4a43d.svg";